// import React, { useState } from 'react'
import Button from '../components/Button'
import CustomeIcon from '../components/CustomeIcon'
// import RadioButton from './RadioButton'

import RadioButton from '../components/RadioButton'

// import { use3DContext } from '../store/threedProvider'

const PopUp = (props) => {

    let popdataCategory = {}

    popdataCategory.closefunc = props.closeRadioPopUpf
    popdataCategory.selectProdP = props.selectProdP


    popdataCategory.productStateSelectContext = props.productStateSelectContext //
    popdataCategory.popUp = props.popUp //
    // popdataCategory.popUpId = props.popUpId //
    popdataCategory.camSequence =  props.camSequence //
    popdataCategory.camSequencetwo =  props.camSequencetwo //
    popdataCategory.itemCategory =  props.itemCategory //
    popdataCategory.cardDetails =  props.cardDetails //

    popdataCategory.classList =  props.classList
    popdataCategory.accordionClick =  props.accordionClick

    popdataCategory.id=props.id
    popdataCategory.menuItems=props.menuItems

    popdataCategory.popUpUniqueId=props.popUpUniqueId


    return (

        props?.popUp?.popupContent && props?.popUp?.popupContent?.map((popUpdata, popUpIndex) => {


            return (

                <div className='landingZonepopup'
                    key={popUpIndex}
                // id={props.popUpId}
                >
                    <div className='popUpWidth'>
                        <Button 
                        
                        clickFunction={props.closeRadioPopUpf} 
                        data={popdataCategory}
                        classList="closePopup">&#10005;</Button>
                        <div className='popupContent'>
                            <p className='popUpheaderContent popUptext'>
                                {popUpdata.title}
                                {/* {requiredArr.title} */}
                            </p>

                            <ul className='lzoneText'>
                                <CustomeIcon src="./images/landingZoneRadio.svg"></CustomeIcon>
                                <RadioButton btnId={props.id+"seven"} type="radio" name="kitchenZone" value="zoneSeven" 
                                // data={props.productStateSelectContext}
                             
                                data={popdataCategory}
                                // info={popdataCategory}

                                classList="popUpZoneSevenBtn"
                                onchangeFunction={props.accordionClick}
                                
                                ></RadioButton>
                                <label className="popup_label"
                                    // htmlFor="kitchenZonethree"
                                    htmlFor={props.id+"seven"}
                                // for="kitchenZonethree"
                                >
                                    {popUpdata.zoneSeven}
                                    {/* {requiredArr.zoneSeven} */}
                                </label>
                            </ul>

                            <ul className='lzoneText'>
                                <CustomeIcon src="./images/landingZoneRadio.svg"></CustomeIcon>
                                <RadioButton btnId={props.id+"three"} type="radio" name="kitchenZone" value="zoneThree" 
                                // data={props.productStateSelectContext}
                                data={popdataCategory}
                                // info={popdataCategory}
                               
                                classList="popUpZoneThreeBtn"
                                onchangeFunction={props.accordionClick}
                                    

                                ></RadioButton>
                                <label className="popup_label"
                                    // htmlFor="kitchenZoneSeven"
                                    htmlFor={props.id+"three"}
                                // for="kitchenZoneSeven"
                                >
                                    {popUpdata.ZoneThree}
                                    {/* {requiredArr.ZoneThree} */}
                                </label>
                            </ul>

                            <p className='popUpFootercontent popUptext'>
                                {popUpdata.footerTitle}
                                {/* {requiredArr.footerTitle} */}
                            </p>
                        </div>
                    </div>
                </div>
            )
        })
    )
}

export default PopUp